'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import segment, { SegmentDataType, SegmentTypes } from '@flipster/utils/segment';

interface Props<T extends SegmentTypes> {
  name: T;
  withPathProperties?: boolean;
  context?: SegmentDataType[T];
}

export const SegmentPage = <T extends SegmentTypes>({ name, withPathProperties, context }: Props<T>) => {
  const pathname = usePathname();

  useEffect(() => {
    let properties: Record<string, string> | undefined;
    if (withPathProperties) properties = { path: pathname };
    segment.page(name, { ...properties, ...context });
  }, [name, pathname, withPathProperties, context]);

  return null;
};
